import React from "react";
import BookCard2 from "../Bookcard2";
import SectionHdr from "../SectionHeader";

// Define the keyframes for both the entrance and the idle effect
const animationStyles = `
  @keyframes fadeUp {
    0% { opacity: 0; transform: translateY(30px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  
  /* Gentle bobbing/floating effect for idle state */
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }
`;

export default function NewArrivalsSection({ books = [], onView, cart, addCart }) {
    const NEW_BOOKS = books.slice(0, 12);

    if (NEW_BOOKS.length === 0) return null;

    return (
        <section className="section" style={{
            background: "#FDF5F5",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            {/* Inject the styles so the animations run */}
            <style>{animationStyles}</style>

            <SectionHdr pill="JUST RELEASED" />

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: 16,
                paddingBottom: 16
            }}>
                {NEW_BOOKS.map((b, i) => (
                    // Outer div handles the one-time fade-in cascade
                    <div
                        key={b._id || i}
                        style={{
                            animation: `fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${i * 0.08}s both`
                        }}
                    >
                        {/* Inner div handles the infinite floating. 
                            We delay it by 1 second so the fadeUp finishes first, 
                            and stagger the float so they don't all move in robotic unison. */}
                        <div
                            style={{
                                animation: `float 4s ease-in-out ${1 + (i * 0.2)}s infinite`
                            }}
                        >
                            <BookCard2 book={b} onView={onView} cart={cart} addCart={addCart} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}